import {Transition, type TransitionProps} from '@mantine/core';
import {BasicButton} from '@packages/ui';

type Props = Omit<TransitionProps, 'children'> & {
  entryURL: string;
  className?: string;
  buttonClassName?: string;
};

export const TransitionEntryButton: React.FC<Props> = ({
  entryURL,
  className,
  buttonClassName,
  ...transitionProps
}: Props) => {
  return (
    <Transition {...transitionProps}>
      {(styles) => (
        <div className={className} style={styles}>
          <div className="flex justify-center flex-wrap mb-16 pc:py-8 pc:mb-0">
            <a
              href={entryURL}
              target="_blank"
              rel="noopener noreferrer"
              id="recruiting_info_entry_button"
            >
              <BasicButton
                label="エントリー"
                className={buttonClassName}
                isPrimary={false}
                isLarge={false}
                isDisabled={false}
              />
            </a>
          </div>
        </div>
      )}
    </Transition>
  );
};
